import type { ErrorMessage, TextErrorKey } from '@1trading/fast-api-domain/forms';

import i18n from '@/lib/i18n';

// Messages are functions, resolved when the field is validated, so a later validation picks up a language switch
const tooLong: ErrorMessage = (issue) => i18n.t('invalidField.tooLong', { x: issue.maximum });

// A value that isn't a string, such as a field never filled in, fails as INVALID but is worded as missing
const invalidOrMissing =
  (invalidKey: string, requiredKey: string): ErrorMessage =>
  (issue) =>
    i18n.t(issue.code === 'invalid_type' ? requiredKey : invalidKey);

const textErrorsWith =
  (invalidKey: string) =>
  (requiredKey: string): Record<TextErrorKey, ErrorMessage> => ({
    REQUIRED: () => i18n.t(requiredKey),
    TOO_LONG: tooLong,
    INVALID: invalidOrMissing(invalidKey, requiredKey),
  });

/** @param requiredKey translation key of the message for a missing name */
export const nameErrors = textErrorsWith('invalidField.name');

/** @param requiredKey translation key of the message for a missing answer */
export const textErrors = textErrorsWith('invalidField.text');

/** @param requiredKey translation key of the message for a missing registration number, tax ID or similar reference */
export const identifierErrors = textErrorsWith('invalidField.identifier');

export const postalCodeErrors = (invalidKey: string): Record<'INVALID', ErrorMessage> => ({
  INVALID: () => i18n.t(invalidKey),
});
